"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _StandardIconWrapper = _interopRequireDefault(require("./StandardIconWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var TopologyViewIcon =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(TopologyViewIcon, _React$PureComponent);

  function TopologyViewIcon() {
    _classCallCheck(this, TopologyViewIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(TopologyViewIcon).apply(this, arguments));
  }

  _createClass(TopologyViewIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          color = _this$props.color,
          className = _this$props.className,
          props = _objectWithoutProperties(_this$props, ["color", "className"]);
      /* eslint-disable max-len */


      return _react.default.createElement(_StandardIconWrapper.default, _extends({
        className: (0, _classnames.default)(className, 'topology-view-icon')
      }, props), _react.default.createElement("path", {
        fill: color,
        d: "M11.4404105,8.25334406 C10.6942911,7.50784088 9.47945563,7.50784088 8.73333623,8.25334406 L8.73237967,8.25334406 C8.48271664,8.50407813 8.32392713,8.8093612 8.24166268,9.12995628 L5.73164051,9.12899928 C5.67233358,8.83328621 5.55850254,8.54810014 5.38632114,8.28779607 L8.1603548,5.51345238 C8.89403887,5.94601649 9.85442845,5.85414446 10.4838471,5.22443831 C11.2299665,4.47797812 11.2299665,3.26258782 10.4838471,2.51612763 C9.73772773,1.76966744 8.5228923,1.76966744 7.7767729,2.51612763 C7.14926736,3.14391979 7.05648072,4.10092003 7.48502109,4.83493921 L4.70620462,7.6150249 C4.45080221,7.45137786 4.16574634,7.34132284 3.8692117,7.28485982 L3.8692117,4.75933619 C4.18966042,4.67703417 4.49384756,4.51817213 4.74446715,4.26743807 C5.10509153,3.90569198 5.3040567,3.42432086 5.3040567,2.91328273 C5.3040567,2.4012876 5.10509153,1.91991648 4.74446715,1.55912739 C3.99739119,0.813624203 2.78351233,0.813624203 2.03739293,1.55912739 C1.29127353,2.30463058 1.29127353,3.52002088 2.03739293,4.26743807 C2.28801252,4.51817213 2.59219966,4.67703417 2.91264838,4.75933619 L2.91264838,7.28390282 C2.46115048,7.37098984 2.03356668,7.5805729 1.69876951,7.91456598 C0.767076829,8.84859821 0.767076829,10.3664006 1.69876951,11.3004328 C2.1502674,11.7511799 2.75194574,12 3.39093004,12 C4.02991434,12 4.63063611,11.7511799 5.08213401,11.3004328 C5.4264968,10.9549557 5.64172355,10.5310046 5.73164051,10.0859995 L8.24166268,10.0869565 C8.32392713,10.4065946 8.48271664,10.7109207 8.73333623,10.9616547 C9.10639593,11.3348848 9.59615635,11.5214999 10.0868733,11.5214999 C10.5766338,11.5214999 11.0673508,11.3348848 11.4404105,10.9616547 C12.1865298,10.2161516 12.1865298,9.00076125 11.4404105,8.25334406"
      }));
      /* eslint-enable max-len */
    }
  }]);

  return TopologyViewIcon;
}(_react.default.PureComponent);

exports.default = TopologyViewIcon;
TopologyViewIcon.defaultProps = {
  color: 'inherit'
};
TopologyViewIcon.propTypes = {
  className: _propTypes.default.string,
  color: _propTypes.default.string
};